import Modal from '@src/basic-components/Modal';
import useModal, { type UseModal } from '@src/hooks/use-modal';
import { createContext, type JSX } from 'react';

const ModalContext = createContext<UseModal>({} as UseModal);

const ModalProvider = ({ children }): JSX.Element => {
    const { modal, handleModal, modalContent, modalProps } = useModal();

    return (
        <ModalContext.Provider value={{ modal, handleModal, modalContent, modalProps }}>
            <Modal {...modalProps} />
            {children}
        </ModalContext.Provider>
    );
};

export { ModalContext, ModalProvider };
